import { cn } from "@/lib/utils";

interface IProps {
  image: string;
  heading: string;
  onClick: (id: number) => void;
  id: number;
}

export const CardWithImageAndHeading = ({
  image,
  heading,
  onClick,
  id,
}: IProps) => {
  return (
    <div
      className={cn(
        "rounded-md cursor-pointer px-3 py-2 flex flex-col justify-center items-center shadow-md m-1 transition-colors",
        "bg-card hover:bg-subtle dark:hover:bg-accent"
      )}
      onClick={() => onClick(id)}
    >
      <img 
        src={image} 
        alt={heading}
        className={`w-10 h-10 card-with-image-and-heading-${heading}`}
      />
      <h6 className="font-normal text-[11px] text-center mt-2 text-muted-foreground">
        {heading}
      </h6>
    </div>
  );
};
